import { useTranslation } from "react-i18next";
import {
  Grid as MuiGrid,
  Typography as MuiTypography,
  Link as MuiLink,
} from "@mui/material";
import { Clear as ClearIcon } from "@mui/icons-material";

export const ResetFilter = ({ resetFn }) => {
  const { t } = useTranslation();

  return (
    <MuiGrid container size={12}>
      <ClearIcon sx={{ fontSize: "18.75px", alignSelf: "center" }} />
      <MuiLink
        component="button"
        underline="none"
        color="textPrimary"
        onClick={() => resetFn({ action: "RESET" })}
      >
        <MuiTypography variant="body2" sx={{ letterSpacing: "normal" }}>
          {t("dashboard.action.filter.resetLabel")}
        </MuiTypography>
      </MuiLink>
    </MuiGrid>
  );
};
